import api from './api';

const commissionMessagesService = {
  // Get all messages for a specific commission
  getMessages: async (commissionId) => {
    const response = await api.get(`/commission-messages/commission/${commissionId}`);
    return response.data;
  },

  // Send a message from admin to agent
  sendAdminMessage: async (commissionId, message) => {
    const response = await api.post('/commission-messages/send-admin-message', {
      commissionId,
      message
    });
    return response.data;
  },

  // Send a reply from agent to admin
  sendAgentReply: async (commissionId, message) => {
    const response = await api.post('/commission-messages/send-agent-reply', {
      commissionId,
      message
    });
    return response.data;
  },

  // Mark messages as read for an agent
  markAsRead: async (commissionId) => {
    const response = await api.post(`/commission-messages/mark-read/${commissionId}`);
    return response.data;
  }
};

export default commissionMessagesService;
